export default __webpack_public_path__ + "static/media/050-safety box.c48d959a.svg";